// import tingle from 'tingle.js';
$(document).ready(function() {
    // const closeBtn = document.querySelector('.tingle-modal__close--home');
    $('.tingle-modal__close--home').click(() => {
        $('.tingle-modal__home').hide();
    });
});
